import { useRouter } from 'next/router';
import { BriefReppl } from './brief-reppl';
import { Team } from './team';
import { CreateEpisode } from './create-episode';
import type { Reppl, RepplCreator } from '../service';

interface SideWidgetProps {
  creator: RepplCreator;
  reppl?: Reppl;
  loading: boolean;
}

export function SideWidget({
  loading,
  reppl,
}: // ...props
SideWidgetProps) {
  // TODO:
  // const shouldShowCreateEpisode = canSubmitEpisode(reppl);
  // const canEdit = isEditable(reppl?.userRole);
  const router = useRouter();

  if (loading) {
    return (
      <div className="animate-pulse w-full">
        <div className="h-72 skeleton-line bg-white mb-4" />
        <div className="h-72 skeleton-line bg-white mb-4" />
        <div className="h-72 skeleton-line bg-white" />
      </div>
    );
  }
  const sortedTeamMembers = reppl?.team.sort(
    (a, b) => Number(a.role) - Number(b.role)
  );

  return (
    <div className="relative">
      {router.query.episodeType && (
        <div className="mb-4">
          <CreateEpisode reppl={reppl} />
        </div>
      )}
      <div className="pb-4">
        <BriefReppl reppl={reppl} loading={loading} />
      </div>
      <div className="pb-4">
        <Team rid={reppl?.id} members={sortedTeamMembers} loading={loading} />
      </div>
      {/* TODO: */}
      {/* <Stack
        spacing={3}
        direction={{ base: 'column', sm: 'column', md: 'row', xl: 'column' }}
        wrap="wrap"
      >
        <Community />
        <Campaign />
      </Stack> */}
    </div>
  );
}
